var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('statistical-header',{attrs:{"title":_vm.title}}),(_vm.loading)?_c('loader'):_vm._e(),(!_vm.loading)?_c('timeline',{attrs:{"id":"timeline","chartData":_vm.chartData}}):_vm._e(),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }